import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Divider } from '..';
import { Popover } from '../Popover';
import { IconButton } from '../IconButton';
import { More } from '@wix/wix-ui-icons-common';
import { classes } from './Divider.visual.st.css';

visualize('Divider', () => {
  story('direction', () => {
    snap('horizontal', () => (
      <div className={classes.containerHorizontal}>
        <span className={classes.textMargin}>Content above</span>
        <Divider />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));

    snap('vertical', () => (
      <div className={classes.containerVertical}>
        <span className={classes.textMargin}>Left content</span>
        <Divider direction="vertical" />
        <span className={classes.textMargin}>Right content</span>
      </div>
    ));
  });

  story('middle divider', () => {
    snap('horizontal', () => {
      const PopoverComponent = () => (
        <Popover placement="bottom" shown={true}>
          <Popover.Element>
            <IconButton icon={<More />} />
          </Popover.Element>
          <Popover.Content>
            <div className={classes.popoverContainer}>
              <span className={classes.textMargin}>Download</span>
              <span className={classes.textMargin}>Edit</span>
              <span className={classes.textMargin}>Add</span>
              <Divider />
              <span className={classes.textMargin}>Delete</span>
            </div>
          </Popover.Content>
        </Popover>
      );
      return <PopoverComponent />;
    });

    snap('vertical', () => {
      const PopoverComponent = () => (
        <Popover placement="bottom" shown={true}>
          <Popover.Element>
            <IconButton icon={<More />} />
          </Popover.Element>
          <Popover.Content>
            <div className={classes.popoverContainer}>
              <div className={classes.verticalInPopover}>
                <div className={classes.textCenter}>
                  <span>42</span>
                  <span>Posts</span>
                </div>
                <Divider direction="vertical" />
                <div className={classes.textCenter}>
                  <span>128</span>
                  <span>Followers</span>
                </div>
              </div>
            </div>
          </Popover.Content>
        </Popover>
      );
      return <PopoverComponent />;
    });
  });

  story('color overrides', () => {
    snap('wst color override green', () => (
      <div className={classes.containerHorizontal}>
        <span className={classes.textMargin}>Wst green override</span>
        <Divider className={classes.wstColor} />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));
    snap('tpa overrides wst red', () => (
      <div className={classes.containerHorizontal}>
        <span className={classes.textMargin}>TPA red overrides wst</span>
        <Divider className={classes.tpaColor} />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));
  });

  story('width overrides', () => {
    snap('wst width override 4px', () => (
      <div className={classes.containerVertical}>
        <span className={classes.textMargin}>Wst thick (4px)</span>
        <Divider className={classes.wstWidth} direction="vertical" />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));
    snap('tpa width override 8px', () => (
      <div className={classes.containerVertical}>
        <span className={classes.textMargin}>Tpa extra thick (8px)</span>
        <Divider className={classes.tpaWidth} direction="vertical" />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));
  });

  story('opacity overrides', () => {
    snap('Opacity override red 30%', () => (
      <div className={classes.containerHorizontal}>
        <span className={classes.textMargin}>Opacity override red 30%</span>
        <Divider className={classes.opacityOverride} />
        <span className={classes.textMargin}>Content below</span>
      </div>
    ));
  });
});
